// 再加工state (主要用于对数组、对象、变量的再加工)
// 命名规范：驼峰命名法
// 按类划分 == 依赖state变量名
import { DEFAULTAVATAR } from '@/utils/const';

// 全局组件
export const showGcContainer = state => {
	return (
		state.tooltip ||
		state.loading ||
		state.agreement_box ||
		state.dialog_alert ||
		state.dialog_affirm ||
		state.vip_success ||
		state.zs_declaration ||
		state.word_explain ||
		state.auth_dialog
	);
};

export const showGcContent = state => {
	return state.tooltip || state.loading;
};

export const showGcContentShade = state => {
	return (
		state.agreement_box ||
		state.dialog_alert ||
		state.dialog_affirm ||
		state.vip_success ||
		state.zs_declaration ||
		state.auth_dialog
	);
};

export const showDialog = state => {
	return state.dialog_alert || state.dialog_affirm;
};

export const showAuthDialog = state => {
	return state.auth_dialog;
};

export const showGcContentShadeComposingNormal = state => {
	return state.word_explain;
};
export const calcAvatarurl = () => url => {
	return url && url.indexOf('/img/default/avatar.jpg') === -1 ? url : DEFAULTAVATAR;
};

// 电子签预览信息

export const getVisaViewInfo = state => {
	return state.visaViewInfo;
};
